/**
 * Strings that appear in more than one place.
 *
 * The product is pt-BR throughout -- there is no second locale and no
 * translation layer, because inventing one before there is a second language to
 * put in it buys nothing. Page-specific copy lives with its page; what is here
 * is what would otherwise be re-typed, and re-typed differently.
 */
export const APP_NAME = 'vylife';

export const ACTIONS = {
  retry: 'Tentar de novo',
  signIn: 'Entrar',
  signOut: 'Sair',
  goToMyArea: 'Ir para a minha área',
  close: 'Fechar',
} as const;

export const LOADING_DEFAULT = 'Carregando…';

/**
 * The simulated-clock control in the header (#360).
 *
 * It exists on staging and on a developer's machine and nowhere else -- in
 * production the API does not serve the resource it reads, so none of this is
 * ever rendered. The wording is blunt on purpose: somebody reading a cutoff
 * date off one of these screens has to be able to tell at a glance that the
 * date is invented, and "modo de teste" would not have told them which part of
 * what they are looking at is fake.
 */
export const SIMULATED_CLOCK = {
  /** Names the control for screen readers. The header shows no visible title. */
  region: 'Tempo simulado',
  /** The badge. Short, because it sits between the brand and the account. */
  badge: 'Tempo simulado',
  /** Reads: "O sistema está operando como se fosse 20/08/2026 09:00". */
  active: (simulatedNow: string) => `O sistema está operando como se fosse ${simulatedNow}`,
  /** The machine's own clock, shown beside the invented one so the two can be told apart. */
  realNow: (realNow: string) => `Tempo real: ${realNow}`,
  /** Shown to a principal who may move the clock, while nothing is simulated. */
  inactive: 'O sistema está no tempo real.',
  field: 'Simular data e hora',
  set: 'Aplicar',
  clear: 'Voltar ao tempo real',
  /** When the clock refuses a change. The control stays on screen. */
  failed: 'Não foi possível mudar o relógio desta instalação.',
} as const;
